import React from "react";
import { Link } from "react-router-dom";

const PlatformPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Platform Overview</h1>
        <p className="subpage-body">
          FeraBio is a connected platform for nanopore sequencing workflows,
          from raw signal upload to basecalling, downstream analysis, and
          collaborative result sharing.
        </p>
        <div className="subpage-visual">
          <div className="subpage-visual-media">
            Placeholder image: end-to-end workflow (upload to cloud processing
            to results)
          </div>
          <div className="subpage-visual-notes">
            <h2>What is most useful on this page</h2>
            <ul>
              <li>One architecture diagram that explains the full workflow.</li>
              <li>
                One screenshot showing where a run is monitored in real time.
              </li>
              <li>One result view that highlights share/export actions.</li>
            </ul>
          </div>
        </div>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: run intake screen
            </div>
            <h3>Start Runs Faster</h3>
            <p>
              Upload datasets and references quickly with a standardized intake
              flow built for reproducibility.
            </p>
            <Link to="/resources#quickstart" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: job queue and compute scaling view
            </div>
            <h3>Run Cloud Analysis</h3>
            <p>
              Launch scalable basecalling and analysis jobs without managing GPU
              infrastructure.
            </p>
            <Link to="/product/basecalling" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: shared dashboard and exports panel
            </div>
            <h3>Collaborate on Results</h3>
            <p>
              Review visualizations, compare runs, and share exports with your
              team from one workspace.
            </p>
            <Link to="/product/tools" className="read-more-link">
              Read more
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformPage;
